<template>
  <div class="col-variable mb-20" @click="selectIdc">
    <label :class="['card', 'card-inner', 'pt-20', 'pl-10', 'pr-10', isCheckd]">
      <div class="box-body pr-0" >
        <div class="card_icon" style="height:60px;display:flex;align-items: center">
          <img :src="logo" :style="{ height: getHeight}"/>
        </div>
        <div class="card-detail pb-20">
          <h4 class="mt-20 mb-10">
            {{idcData.locationName}}
          </h4>

          <p class="mt-5" v-if="idcData && idcData.idcInfomation"><span class="mr-10"><i class="icon-global"></i></span>{{idcData.idcInfomation.address}} {{idcData.idcInfomation.building}}</p>
          <p class="mt-5" v-if="idcData && idcData.idcInfomation"><span class="mr-10"><i class="icon-telephone"></i></span>{{idcData.idcInfomation.tel}}</p>
        </div>
        <span class="bar"></span>
        <div class="inner-footer pr-5">

          <div v-if="idcData && idcData.idcInfomation" class="btn btn-md flat text-blue pull-right" @click="openMap(idcData.idcInfomation.map)">지도보기</div>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    idcData: Object,
  },
  computed: {
    getHeight(){
      if(this.idcData == null) return '20px';
      else if(this.idcData.idcInfomation == null) return '20px';
      else if(this.idcData.idcInfomation.company.toLowerCase().replace(/ /g,"") == 'naver') return '20px';
      else if(this.idcData.idcInfomation.company.toLowerCase().replace(/ /g,"") == '롯데정보통신') return '30px';
      else if(this.idcData.idcInfomation.company.toLowerCase().replace(/ /g,"") == 'skc&c') return '40px';
      else if(this.idcData.idcInfomation.company.toLowerCase().replace(/ /g,"") == 'skb') return '40px';
      else return '25px';
    },
    isCheckd(){
      return this.idcData.isChecked ? 'checked' : '';
    },
    logo(){
      var result = "";
      if(this.idcData && this.idcData.idcInfomation){
        result = '/dist/logo/' + this.idcData.idcInfomation.company.toLowerCase().replace(/ /g,"") + '.png'
      }
      return result;
    }
  },
  methods: {
    selectIdc(){
      this.$emit('selectIdc');

    },
    openMap(map){

      window.open(map, '_blank');
    }
  },
}
</script>

<style>

</style>
